import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MODAL_HIDE } from '../../../constants/action-types';

class UserPromptModalComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="">
               <h4 style={{margin: '1rem 0 2rem'}}>You must log in to perform that action</h4>
               <a href={`/auth#login?redir=${window.location.pathname}`}>
                    <button className='primary'>
                        <div className='flex'>
                            <small>Log in</small>
                        </div>
                    </button>
                </a>
            </div>);
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    closeModal: (email) => dispatch({ type: MODAL_HIDE })
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPromptModalComponent)


// WEBPACK FOOTER //
// ./src/components/templates/modals/user-prompt-login.js